
$( document ).ready(function() {

	///////////////////////////////////////////
	/************** star rating **************/
	///////////////////////////////////////////
	$('.rating_stars').raty({ 
		starType: 'i',
		readOnly:true,
		half:true,
		score: function() {
                      return $(this).attr('data-rating');
                     }
	});

	$("img.lazy").show().lazyload({
	    effect : "fadeIn",
	    threshold : 200
	});

	$(window).scroll(function() {
	  $('.shop_isotope_container').isotope('layout');
	});

	$('.mobile_sub_cat_selector').change(function(){
		window.location.href = $(this).val();
	});
	

	////////////////////////////////////////////////
	/************** End star rating ***************/
	///////////////////////////////////////////////


	/////////////////////////////////////////////////////////////////////////////
	//change view type according to the value stored in the hidden input feild//
	///////////////////////////////////////////////////////////////////////////

	layout_type = $('input[name="layout_type"]').val();
	//if layout is set to null then the default value is the grid view
	if(layout_type!=null){
		//hightlight the button
		if(layout_type=='grid'){
			var self = $('#grid_switcher');
		}else if(layout_type=='list'){
			var self = $('#list_switcher');
		}
		
		self.parent().addClass('active').siblings().removeClass('active');
		//else then apply the needed classes according to they type
		var shopContainer = $('.shop_isotope_container');
		var item = shopContainer.children('.shop_isotope_item');
		//change needed css classes according to the view type
		if(layout_type == "grid"){
			// item.find('.cart_controls_left').addClass('half_column');
			item.find('.cart_controls_left').addClass('f_md_block f_md_none');
			// item.find('.cart_color_options').find('.cart_controls_left').addClass('w_sm_half_column');
			// item.find('.cart_color_options').find('.cart_controls_right').addClass('w_sm_half_column');
			// item.find('.cart_controls_right').addClass('half_column');
			item.find('.cart_controls_right').addClass('f_md_block f_md_none');
			item.find('.bb-bookblock').removeClass('f_left').addClass('auto_width');
			item.removeClass('list_view')
				.find('.fp_item').removeClass('t_align_l')
				.children('.relative').removeClass('f_left m_right_20 f_xs_none');
			item.find('.fp_item').find('.fp_price').addClass('t_align_c')
				.removeClass('f_left').next().removeClass('f_right t_sm_align_l f_xs_none d_xs_block w_xs_full').addClass('half_column t_sm_align_r')
				.parent().removeClass('wrapper m_bottom_15').addClass('m_bottom_10');
				item.each(function(){
					$(this).find('figcaption').children('.fp_buttons').children(":first").addClass('half_column ')
					.removeClass('f_xs_left w_xs_auto').next().addClass('half_column').removeClass('f_xs_left w_xs_auto').children('a:not(.tooltip_container)').removeClass('m_xs_right_8');;
				});
			item.find('.reviews').removeClass('d_inline_b').addClass('d_block');
			item.find('.product_description').addClass('d_none').removeClass('d_block');
			item.find('figcaption').css('text-align','center');
		}
		else{
			item.find('.cart_controls_left').removeClass('half_column');
			item.find('.cart_controls_left').removeClass('f_md_block f_md_none');
			item.find('.cart_color_options').find('.cart_controls_left').removeClass('w_sm_half_column');
			item.find('.cart_color_options').find('.cart_controls_right').removeClass('w_sm_half_column');
			item.find('.cart_controls_right').removeClass('half_column');
			item.find('.cart_controls_right').removeClass('f_md_block f_md_none');
			item.find('.bb-bookblock').removeClass('auto_width').addClass('f_left');
			item.addClass('list_view').find('.fp_item')
				.addClass('t_align_l').children('.relative')
				.addClass('f_left m_right_20 m_xs_right_0 f_xs_none');
			item.find('.fp_item').find('.fp_price').removeClass('half_column')
				.next().addClass('f_right t_sm_align_r f_xs_none d_xs_block w_xs_full').removeClass('half_column  t_sm_align_r')
				.parent().addClass('wrapper m_bottom_15').removeClass('m_bottom_10');
			item.find('figcaption').children('.fp_buttons').children('.half_column').addClass('f_xs_c w_xs_auto')
				.removeClass('half_column ').children('a:not(.tooltip_container)').addClass('m_xs_right_8');
			item.find('.reviews').removeClass('d_block').addClass('d_inline_b');
			item.find('.product_description').removeClass('d_none').addClass('d_block');
			item.find('figcaption').addClass('t_md_align_l');
			item.find('figcaption').css('text-align','none');
		} 
		//trigger the isotope plugin
		shopContainer.isotope('layout');
	}

	////////////////////////////////////////////////////////////////////////////////
	//end change view type according to the value stored in the hidden input feild//
	///////////////////////////////////////////////////////////////////////////////


	////////////////////////////////////////////////////////////////////////////////////////////////
	//////////// Adding the needed links to the top, bottom per page lists and top sorting menu/////
	///////////////////////////////////////////////////////////////////////////////////////////////

	// $('#top_items_per_page_selector').change(function(){
	// 	alter_category_view('per_page',$(this).val());
	// });

	// $('#bottom_items_per_page_selector').change(function(){
	// 	alter_category_view('per_page',$(this).val());
	// });

	$('#sorting_options_list').change(function(){
		alter_category_view('sort',$(this).val());
	});

	//////////////////////////////////////////////////////////////////////////////
	//////// End adding the needed links to the top and bottom per page lists////
	////////////////////////////////////////////////////////////////////////////


});

function alter_category_view(type,value)
{
	type = type;
	$.ajax({
        type:       'POST',
        url:        base_url+'/category/alter_categories_view/'+type+'/'+value,
        dataType:   'json',
        beforeSend : function (){
        	//display the loader
        	showLoader();
		},
        success:  function(json){
            	if(json.status=='success'){
        			//reload the page
        			if(type=='per_page'){
        				loc = window.location.href.split('?')[0];
        				window.location.href = loc;
        			}else{
        				location.reload();
        			}	
    		}
   	 	}
	});
}